import React from "react";

const Logo = () => {
  return <span className="logo">Pierre-Olivier B.</span>;
};

export default Logo;
